define('results_view_factory',['bootstrap', 'results_view'], function (news, ResultsView) {

    return {
        setupResultsView: function (elm, vocab, allFeedback) {
            var resultsView = ResultsView;
            resultsView.init(elm, vocab, allFeedback);
            return resultsView;
        }
    };

});

